export default __webpack_public_path__ + "static/media/O_VT_N1_2.e41e1c9b.mp4";